module.exports = __webpack_public_path__ + "media/images/img/tag_company/iij_tag-c1f8ded5db5b52933528de90352b5121.png";